import { RyftNonHostedBalance } from "~/pages/ryftNonHosted/dashboard/RyftNonHostedBalance";
import { FinanceSettingsOof } from "../pages/settings/financeSettings/FinanceSettingsOof";
import { RyftPaymentSessionRedirect } from "~/pages/stockList/checkoutV2/RyftPaymentSessionRedirect";
import { SupplierDistribution } from "../pages/delivery/SupplierDistribution";
import { RyftNonHostedDashboardLayout } from "~/pages/ryftNonHosted/dashboard/RyftNonHostedDashboardLayout";
import { RyftNonHostedAccounts } from "~/pages/ryftNonHosted/dashboard/RyftNonHostedAccounts";
import { RyftNonHostedDocuments } from "~/pages/ryftNonHosted/dashboard/RyftNonHostedDocuments";
import { ReactElement } from "react";
import { Navigate, Outlet, Route } from "react-router";
import { OrderDeliveryNote, OrderInvoice } from "../components";
import { Dashboard } from "../components/dashboard/Dashboard";
import { OrderCreateConsignment } from "../components/newOrderSummary/OrderCreateConsignment/OrderCreateConsignment";
import * as ROUTES from "../constants/routes";
import { useAppInitialization } from "../hooks/useAppInitialization";
import { BusinessEditSettings, Order, PriceTier, PriceTiers } from "../pages";
import { Analytics } from "../pages/analytics/Analytics";
import { CollectionDetails } from "../pages/collections/CollectionDetails";
import { CollectionsList } from "../pages/collections/CollectionsList";
import { NewCollection } from "../pages/collections/NewCollection";
import { CustomerListNew } from "../pages/customer/CustomerListNew";
import { NewVenue } from "../pages/customer/NewVenue";
import { BuyerPage } from "../pages/customer/buyerSearch/BuyerPage";
import { BuyerSearchList } from "../pages/customer/buyerSearch/BuyerSearchList";
import { DeliveryArea } from "../pages/deliveryAreas/DeliveryArea";
import { DeliveryTiers, ForDeliveryMethod } from "../pages/deliveryCharges";
import { DeliverySettings } from "../pages/deliverySettings/DeliverySettings";
import { EducateConnect } from "../pages/educateConnect/EducateConnect";
import { MessagesDashboard } from "../pages/messages/MessageDashboard";
import { MessageThreadPage } from "../pages/messages/MessageThreadPage";
import { OrderCommentPage } from "../pages/messages/OrderCommentPage";
import { OrderEdit } from "../pages/order/edit/OrderEdit";
import { DraftOrders } from "../pages/order/list/drafts/DraftOrders";
import { Orders } from "../pages/order/list/Orders";
import { OrderConfirmation } from "../pages/order/OrderConfirmation";
import { OrderOnBehalfOf } from "../pages/order/orderOnBehalfOf/OrderOnBehalfOf";
import { Notification } from "../pages/notification/Notification";
import { SellarCreditPaymentLink } from "../pages/paymentLinks/SellarCreditPaymentLink";
import { PriceTierEdit } from "../pages/priceTiers/priceTier/edit/PriceTierEdit";
import { ProductAddV2 } from "../pages/product/list/v2/ProductAddV2";
import { ProductCategoryV2 } from "../pages/product/list/v2/ProductCategory/ProductCategoryV2";
import { ProductEditV2 } from "../pages/product/list/v2/ProductEditV2";
import { ProductListRoute } from "../pages/product/list/v2/ProductListRoute";
import { BuyerConnectedSupplierList } from "../pages/buyer/connectedSuppliers/BuyerConnectedSupplierList";
import { BusinessSettings } from "../pages/settings/businessSettings/BusinessSettings";
import { StorefrontContent } from "../pages/settings/configureStoreSettings/StorefrontContent";
import { StorefrontSettings } from "../pages/settings/configureStoreSettings/StorefrontSettings";
import { FeatureFlagsSettings } from "../pages/settings/featureFlagSettings/FeatureFlagsSettings";
import { IntegrationConnectionConfirm } from "../pages/settings/integrationSettings/IntegrationConnectionConfirm/IntegrationConnectionConfirm";
import { IntegrationSettings } from "../pages/settings/integrationSettings/IntegrationSettings";
import { InvoiceSettings } from "../pages/settings/invoiceSettings/InvoiceSettings";
import { NotificationPreferences } from "../pages/settings/notificationSettings/NotificationSettings";
import { NotificationPreferencesLegacy } from "../pages/settings/notificationSettings/NotificationSettingsLegacy";
import { PaymentMethodSettings } from "../pages/settings/paymentMethodSettings/PaymentMethodSettings";
import {
  AccountSettingsList,
  BusinessSettingsList,
} from "../pages/settings/SettingsList";
import { TermsAndConditions } from "../pages/settings/termsAndConditions/TermsAndConditions";
import { UserSettings } from "../pages/settings/userSettings/UserSettings";
import { StorefrontLayoutRoute } from "../pages/stockList/categoryPage/Storefront/StorefrontLayout/StorefrontLayoutRoute";
import { StorefrontShare } from "../pages/stockList/categoryPage/Storefront/StorefrontShare/StorefrontShare";
import { StockOverview } from "../pages/stockOverview/pages/StockOverview";
import { StockOverviewProduct } from "../pages/stockOverview/pages/StockOverviewProduct";
import { StorefrontLinksV2 } from "../pages/storefrontLinks/v2/StorefrontLinksV2";
import { StorefrontLinksV2Redirect } from "../pages/storefrontLinks/v2/StorefrontLinksV2Redirect";
import { SupplierCreatePage } from "../pages/supplier/SupplierCreatePage";
import { renderAuthenticatedCheckoutRoutes } from "../routing/renderAuthenticatedCheckoutRoutes";
import {
  CustomerConversationRoute,
  CustomerOrderRoute,
  CustomerRoute,
} from "./CustomerRoutes";
import { ManageCompanySettings } from "../pages/sellarCredit/pages/ManageCompanySettings";
import { SellarCreditGetStarted } from "../pages/sellarCredit/pages/SellarCreditGetStarted/SellarCreditGetStarted";
import { FinanceSettingsInvoices } from "../pages/settings/financeSettings/FinanceSettingsInvoices";
import { FinanceSettingsSellarCredit } from "../pages/settings/financeSettings/FinanceSettingsSellarCredit";
import { FinanceSettingsPayout } from "../pages/settings/financeSettings/FinanceSettingsPayout";
import { SellarCreditTab } from "../pages/sellarCredit/pages/SellarCreditTab/SellarCreditTab";
import { SellarCreditStatement } from "../pages/sellarCredit/pages/SellarCreditStatement/SellarCreditStatement";
import { AvailabilityLists } from "../pages/availability/AvailabilityLists";
import { AvailabilityTier } from "../pages/availability/AvailabilityTier";
import { AvailabilityTierNew } from "../pages/availability/AvailabilityTierNew";
import { CustomerZoneLists } from "../pages/customerZones/CustomerZoneLists";
import { CustomerZone } from "../pages/customerZones/CustomerZone";
import { OrderRules } from "../pages/orderRules/list/OrderRules";
import { OrderRule } from "../pages/orderRules/orderRule/OrderRule";
import { PriceListLists } from "../pages/priceLists/PriceListLists";
import { PriceList } from "../pages/priceLists/PriceList";
import { PriceLists } from "../pages/priceLists/PriceLists";
import { VolumeDiscountsList } from "../pages/priceLists/VolumeDiscountsList";
import { VolumeDiscount } from "../pages/priceLists/VolumeDiscount";
import {
  GlobalPromotionsPage,
  GlobalPromotionsTab,
} from "../pages/priceLists/GlobalPromotionsTab";
import { FinanceSettingsSellarImports } from "../pages/settings/financeSettings/financeSettingsSellarImports/FinanceSettingsSellarImports";
import { TwoDirectDebitRegistrationPage } from "../pages/settings/twoDirectDebitRegistration/TwoDirectDebitRegistrationPage";
import { SellarCreditProviderSelection } from "../pages/sellarCredit/pages/SellarCreditProviderSelection";
import { DistributionCollectionsList } from "../pages/distribution/DistributionCollectionsList";
import { DistributionProcessingDetails } from "../pages/distribution/DistributionProcessingDetails";
import { DistributionAllocatedDetails } from "../pages/distribution/DistributionAllocatedDetails";
import { DeliveryMethodList } from "../pages/delivery/DeliveryMethodList";
import { DeliveryMethod } from "../pages/delivery/DeliveryMethod";
import { DeliverySettingsV2 } from "../pages/delivery/DeliverySettingsV2";
import { DeliveryScheduleList } from "../pages/delivery/DeliveryScheduleList";
import { DeliveryZones } from "../pages/delivery/DeliveryZones";
import { DeliveryZone } from "../pages/delivery/DeliveryZone";
import { TwoBusinessRegistrationApplication } from "../pages/sellarCredit/pages/TwoBusinessRegistrationApplication/TwoBusinessRegistrationApplication";
import { DistributionPalletShipmentsList } from "../pages/distribution/DistributionPalletShipmentsList";
import { DistributionPalletShipmentDetails } from "../pages/distribution/DistributionPalletShipmentDetails/DistributionPalletShipmentDetails";
import { TwoSellarCreditPaymentAllocationHistory } from "../pages/sellarCredit/pages/SellarCreditPaymentAllocationHistory/TwoSellarCreditPaymentAllocationHistory";
import { PromotionRoute, PromotionStandaloneRoute } from "./PromotionRoutes";
import {
  LegacyBuyerRedirect,
  LegacyBuyersListRedirect,
} from "./LegacyBuyerRedirect";
import { RouteAccessBoundary } from "./RouteAccessBoundary";
import { RyftNonHostedOnboarding } from "~/pages/ryftNonHosted/onboarding/RyftNonHostedOnboarding";
import { RyftNonHostedOnboardingBusiness } from "~/pages/ryftNonHosted/onboarding/RyftNonHostedOnboardingBusiness";
import { RyftNonHostedOnboardingBusinessDirector } from "~/pages/ryftNonHosted/onboarding/RyftNonHostedOnboardingBusinessDirector";
import { RyftNonHostedOnboardingBusinessBankAccount } from "~/pages/ryftNonHosted/onboarding/RyftNonHostedOnboardingBusinessBankAccount";
import { RyftNonHostedOnboardingLayout } from "~/pages/ryftNonHosted/onboarding/RyftNonHostedOnboardingLayout";
import { RyftNonHostedOnboardingTerms } from "~/pages/ryftNonHosted/onboarding/RyftNonHostedOnboardingTerms";

type AuthenticatedBusinessRouteOptions = {
  firebaseUser: ReturnType<typeof useAppInitialization>["firebase"]["user"];
  sellarUser: ReturnType<typeof useAppInitialization>["sellar"]["user"];
  business: ReturnType<
    typeof useAppInitialization
  >["currentBusiness"]["business"];
  invoiceSettingsEnabled: boolean;
  inAppNotificationsActive: boolean;
  unbundlingRelease2bEnabled: boolean;
  unbundlingRelease2aEnabled: boolean;
  unbundlingEnabled: boolean;
  supplierOrderPromotionsEnabled: boolean;
  sellarDistributionBetaEnabled: boolean;
  canManageCompanyCreditSettings: boolean;
  canAccessCreditTab: boolean;
  canAccessOperationalRoutes: boolean;
  renderFallbackRedirect: () => ReactElement;
};

export const renderAuthenticatedBusinessRoutes = ({
  firebaseUser,
  sellarUser,
  business,
  invoiceSettingsEnabled,
  inAppNotificationsActive,
  unbundlingRelease2bEnabled,
  unbundlingRelease2aEnabled,
  unbundlingEnabled,
  supplierOrderPromotionsEnabled,
  sellarDistributionBetaEnabled,
  canManageCompanyCreditSettings,
  canAccessCreditTab,
  canAccessOperationalRoutes,
  renderFallbackRedirect,
}: AuthenticatedBusinessRouteOptions): ReactElement => (
  <Route
    element={
      <RouteAccessBoundary
        isAllowed={canAccessOperationalRoutes}
        renderFallback={() => (
          <Navigate to={ROUTES.SUPPLIER_ONBOARDING} replace />
        )}
      />
    }
  >
    <Route
      element={
        <RouteAccessBoundary
          isAllowed={Boolean(firebaseUser && sellarUser)}
          renderFallback={renderFallbackRedirect}
        />
      }
    >
      <>
        <Route path={ROUTES.NEW_VENUE} element={<NewVenue />} />
        <Route
          element={
            <RouteAccessBoundary
              isAllowed={Boolean(business)}
              renderFallback={renderFallbackRedirect}
            />
          }
        >
          <>
            {renderAuthenticatedCheckoutRoutes()}

            <Route
              path={ROUTES.RYFT_PAYMENT_SESSION_REDIRECT.pattern}
              element={<RyftPaymentSessionRedirect />}
            />

            <Route
              path={ROUTES.ORDERS}
              element={
                <Dashboard
                  width={1024}
                  parentComponent={<Orders />}
                  parentPart={"minmax(400px,45%)"}
                  childPart={"1fr"}
                />
              }
            >
              {business?.Supplier && (
                <Route
                  path={ROUTES.ORDER_EDIT.pattern}
                  element={<OrderEdit />}
                />
              )}
              <Route path={ROUTES.ORDER_DETAILS.pattern} element={<Order />} />
              <Route
                path={ROUTES.ORDER_DELIVERY_NOTE.pattern}
                element={<OrderDeliveryNote />}
              />
              <Route
                path={ROUTES.ORDER_INVOICE.pattern}
                element={<OrderInvoice />}
              />
            </Route>
            <Route
              path={ROUTES.ORDER_CONFIRMATION.pattern}
              element={<OrderConfirmation />}
            />
            <Route path={ROUTES.NOTIFICATIONS} element={<Notification />} />
            <Route
              path={ROUTES.EDIT_PROFILE}
              element={<Navigate to={ROUTES.ACCOUNT_SETTINGS} replace />}
            />
            <Route
              path={ROUTES.ACCOUNT}
              element={
                <Dashboard
                  width={1024}
                  parentComponent={<AccountSettingsList />}
                  parentPart="300px"
                  childPart="1fr"
                />
              }
            >
              <Route
                path={ROUTES.ACCOUNT_SETTINGS}
                element={<UserSettings />}
              />
              <Route
                path={ROUTES.ACCOUNT_NOTIFICATION_SETTINGS}
                element={
                  inAppNotificationsActive ? (
                    <NotificationPreferences />
                  ) : (
                    <NotificationPreferencesLegacy />
                  )
                }
              />
            </Route>
            <Route
              path={ROUTES.BUSINESS}
              element={
                <Dashboard
                  width={1024}
                  parentComponent={<BusinessSettingsList />}
                  parentPart="300px"
                  childPart="1fr"
                />
              }
            >
              <Route
                path={ROUTES.BUSINESS_SETTINGS}
                element={<BusinessSettings />}
              />
              <Route
                path={ROUTES.BUSINESS_EDIT_SETTINGS}
                element={<BusinessEditSettings />}
              />
              <Route
                path={ROUTES.BUSINESS_INTEGRATION_SETTINGS}
                element={<IntegrationSettings />}
              />
              <Route
                path={ROUTES.BUSINESS_INTEGRATION_CONFIRM_SETTINGS}
                element={<IntegrationConnectionConfirm />}
              />
              <Route
                path={ROUTES.BUSINESS_OPENING_ORDER_FEES_SETTINGS}
                element={<Navigate to={ROUTES.BUSINESS_FINANCE_OOF} replace />}
              />
              {invoiceSettingsEnabled && (
                <Route
                  path={ROUTES.BUSINESS_INVOICES_SETTINGS}
                  element={<InvoiceSettings />}
                />
              )}
              <>
                <Route
                  path={ROUTES.BUSINESS_FINANCE_INVOICES}
                  element={<FinanceSettingsInvoices />}
                />
                <Route
                  path={ROUTES.BUSINESS_FINANCE_OOF}
                  element={<FinanceSettingsOof />}
                />

                <Route
                  path={ROUTES.BUSINESS_FINANCE_CREDIT}
                  element={<FinanceSettingsSellarCredit />}
                />

                <Route
                  path={ROUTES.BUSINESS_FINANCE_SELLAR_IMPORTS}
                  element={<FinanceSettingsSellarImports />}
                />

                <Route
                  path={ROUTES.BUSINESS_FINANCE_CREDIT_PAYOUT}
                  element={<FinanceSettingsPayout />}
                />
              </>
              <Route
                path={ROUTES.BUSINESS_PAYMENT_METHOD_SETTINGS}
                element={<PaymentMethodSettings />}
              />
              <Route
                path={ROUTES.BUSINESS_FEATURE_FLAG_SETTINGS}
                element={<FeatureFlagsSettings />}
              />
              <Route
                path={ROUTES.BUSINESS_TERMS_AND_CONDITIONS}
                element={<TermsAndConditions />}
              />
            </Route>

            <Route
              path={ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_DASHBOARD}
              element={<RyftNonHostedDashboardLayout />}
            >
              <Route
                index
                element={
                  <Navigate
                    to={ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ACCOUNTS}
                    replace
                  />
                }
              />
              <Route
                path={ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ACCOUNTS}
                element={<RyftNonHostedAccounts />}
              />
              <Route
                path={ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_DOCUMENTS}
                element={<RyftNonHostedDocuments />}
              />
              <Route
                path={ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_BALANCE}
                element={<RyftNonHostedBalance />}
              />
            </Route>

            <Route
              path={ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ONBOARDING}
              element={<RyftNonHostedOnboardingLayout />}
            >
              <Route index element={<RyftNonHostedOnboarding />} />
              <Route
                path={
                  ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ONBOARDING_BUSINESS
                }
                element={<RyftNonHostedOnboardingBusiness />}
              />
              <Route
                path={
                  ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ONBOARDING_BUSINESS_DIRECTOR
                }
                element={<RyftNonHostedOnboardingBusinessDirector />}
              />
              <Route
                path={
                  ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ONBOARDING_BUSINESS_BANK_ACCOUNT
                }
                element={<RyftNonHostedOnboardingBusinessBankAccount />}
              />
              <Route
                path={
                  ROUTES.BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ONBOARDING_TERMS
                }
                element={<RyftNonHostedOnboardingTerms />}
              />
            </Route>

            <Route
              path={ROUTES.PAYMENT_LINK.pattern}
              element={<SellarCreditPaymentLink />}
            />

            {canAccessCreditTab && (
              <>
                <Route
                  path={ROUTES.SELLAR_CREDIT_CREDIT_PROVIDER_SELECTION}
                  element={<SellarCreditProviderSelection />}
                />
                <Route
                  path={ROUTES.SELLAR_CREDIT_TAB}
                  element={<SellarCreditTab />}
                />
                <Route
                  path={ROUTES.SELLAR_CREDIT_STATEMENT}
                  element={<SellarCreditStatement />}
                />
                <Route
                  path={ROUTES.SELLAR_CREDIT_PAYMENT_ALLOCATION_HISTORY}
                  element={<TwoSellarCreditPaymentAllocationHistory />}
                />
                {canManageCompanyCreditSettings && (
                  <>
                    <Route
                      path={ROUTES.ACCOUNT_MANAGE_COMPANY_SETTINGS}
                      element={
                        <ManageCompanySettings sellarCreditTabView={true} />
                      }
                    />
                    <Route
                      path={ROUTES.SELLAR_CREDIT_MANAGE_COMPANY}
                      element={
                        <ManageCompanySettings sellarCreditTabView={false} />
                      }
                    />
                  </>
                )}
              </>
            )}
          </>
        </Route>
      </>
    </Route>
    <Route
      element={
        <RouteAccessBoundary
          isAllowed={Boolean(sellarUser)}
          renderFallback={renderFallbackRedirect}
        />
      }
    >
      <>
        <Route
          element={
            <RouteAccessBoundary
              isAllowed={Boolean(business)}
              renderFallback={renderFallbackRedirect}
            />
          }
        >
          <>
            {/* TODO: remove in future as deprecated route hence redirect */}
            <Route
              path={ROUTES.CONNECTION_MESSAGE_LIST}
              element={
                <Navigate to={`${ROUTES.DIRECT_MESSAGE_LIST}`} replace />
              }
            />

            <Route
              path={ROUTES.DIRECT_MESSAGE_LIST}
              element={<MessagesDashboard />}
            >
              <Route
                path={ROUTES.DIRECT_MESSAGE.pattern}
                element={<MessageThreadPage />}
              />
            </Route>

            <Route
              path={ROUTES.ORDER_COMMENT_LIST}
              element={<MessagesDashboard />}
            >
              <Route
                path={ROUTES.ORDER_COMMENT.pattern}
                element={<OrderCommentPage />}
              />
            </Route>
            <Route path={ROUTES.DRAFT_ORDERS} element={<DraftOrders />} />
          </>
        </Route>
        {business?.Retailer && (
          <>
            <Route
              path={ROUTES.SUPPLIERS}
              element={<BuyerConnectedSupplierList />}
            />
            <Route path={ROUTES.EDUCATE_CONNECT} element={<EducateConnect />} />
            <Route
              path={ROUTES.SELLAR_CREDIT_TWO_BUSINESS_REGISTRATION_APPLICATION}
              element={<TwoBusinessRegistrationApplication />}
            />
            <Route
              path={ROUTES.SELLAR_CREDIT_GET_STARTED}
              element={<SellarCreditGetStarted />}
            />
            <Route
              path={ROUTES.SELLAR_CREDIT_DIRECT_DEBIT}
              element={<TwoDirectDebitRegistrationPage />}
            />
          </>
        )}
        {business?.Supplier && (
          <>
            <Route path={ROUTES.BUYERS} element={<BuyerSearchList />} />
            <Route
              path={ROUTES.LEGACY_RETAILERS}
              element={<LegacyBuyersListRedirect />}
            />

            <Route path={ROUTES.STOREFRONT_LINKS} element={<Outlet />}>
              <Route index={true} element={<StorefrontLinksV2 />} />
              {/** TODO: Remove this legacy preview redirect after 2026-11-20, three months on from the enableNewStorefrontLinks flag removal. */}
              <Route
                path={ROUTES.STOREFRONT_LINKS_PREVIEW}
                element={<StorefrontLinksV2Redirect />}
              />
            </Route>

            <Route
              path={ROUTES.BUYER.pattern}
              element={
                <Dashboard
                  width={1200}
                  parentComponent={<BuyerSearchList />}
                  parentPart={"1fr"}
                  childPart={"2fr"}
                />
              }
            >
              <Route path={""} element={<BuyerPage />} />
            </Route>
            <Route
              path={ROUTES.LEGACY_RETAILER.pattern}
              element={<LegacyBuyerRedirect />}
            />

            <Route path={ROUTES.ANALYTICS} element={<Analytics />} />
            <Route path={ROUTES.CUSTOMERS} element={<CustomerListNew />} />
            <Route path={ROUTES.CUSTOMER.pattern} element={<CustomerRoute />}>
              <Route
                path={ROUTES.CUSTOMER_CONVERSATION.pattern}
                element={<CustomerConversationRoute />}
              />
              <Route
                path={ROUTES.CUSTOMER_ORDER.pattern}
                element={<CustomerOrderRoute />}
              />
            </Route>
            <Route
              path={ROUTES.ORDER_SUPPLIER.pattern}
              element={<OrderOnBehalfOf />}
            />
            <Route path={ROUTES.NEW_COLLECTION} element={<NewCollection />} />
            <Route
              path={ROUTES.CREATE_CONSIGNMENT.pattern}
              element={<OrderCreateConsignment />}
            />
            <Route
              path={ROUTES.AVAILABILITY_TIERS}
              element={<AvailabilityLists />}
            />
            <Route
              path={ROUTES.AVAILABILITY_TIER.pattern}
              element={<AvailabilityTier />}
            />
            <Route
              path={ROUTES.AVAILABILITY_TIER_NEW}
              element={<AvailabilityTierNew />}
            />
            {!unbundlingEnabled && (
              <>
                <Route
                  path={ROUTES.CUSTOMER_ZONES}
                  element={<CustomerZoneLists />}
                />
                <Route
                  path={ROUTES.CUSTOMER_ZONE.pattern}
                  element={<CustomerZone />}
                />
              </>
            )}
            {unbundlingRelease2bEnabled ? (
              <>
                <Route path={ROUTES.PRICE_LISTS} element={<PriceLists />}>
                  <Route index element={<PriceListLists />} />
                  {unbundlingEnabled && (
                    <Route
                      path={ROUTES.VOLUME_DISCOUNTS}
                      element={<VolumeDiscountsList />}
                    />
                  )}
                  {supplierOrderPromotionsEnabled && (
                    <Route
                      path={ROUTES.PROMOTIONS}
                      element={<GlobalPromotionsTab />}
                    />
                  )}
                </Route>
                <Route
                  path={ROUTES.PRICE_LIST.pattern}
                  element={<PriceList />}
                />
                {unbundlingEnabled && (
                  <Route
                    path={ROUTES.VOLUME_DISCOUNT.pattern}
                    element={<VolumeDiscount />}
                  />
                )}
                {supplierOrderPromotionsEnabled && (
                  <Route
                    path={ROUTES.PROMOTION.pattern}
                    element={<PromotionRoute />}
                  />
                )}
              </>
            ) : (
              <Route
                path={ROUTES.PRICE_TIERS}
                element={
                  <Dashboard
                    width={1024}
                    parentComponent={<PriceTiers />}
                    parentPart={"minmax(400px,30%)"}
                    childPart={"1fr"}
                  />
                }
              >
                <Route
                  path={ROUTES.PRICE_TIER.pattern}
                  element={<PriceTier />}
                />
                <Route
                  path={ROUTES.PRICE_TIER_EDIT.pattern}
                  element={<PriceTierEdit />}
                />
              </Route>
            )}
            {!unbundlingRelease2bEnabled && supplierOrderPromotionsEnabled && (
              <>
                <Route
                  path={ROUTES.PROMOTIONS_STANDALONE}
                  element={<GlobalPromotionsPage />}
                />
                <Route
                  path={ROUTES.PROMOTION_STANDALONE.pattern}
                  element={<PromotionStandaloneRoute />}
                />
              </>
            )}
            {unbundlingRelease2aEnabled && !unbundlingEnabled && (
              <Route
                path={ROUTES.ORDER_RULES}
                element={
                  <Dashboard
                    width={1024}
                    parentComponent={<OrderRules />}
                    parentPart={"minmax(400px,30%)"}
                    childPart={"1fr"}
                  />
                }
              >
                <Route
                  path={ROUTES.ORDER_RULE.pattern}
                  element={<OrderRule />}
                />
              </Route>
            )}
            <Route path={ROUTES.PRODUCT_LIST} element={<ProductListRoute />}>
              <Route path={ROUTES.NEW_PRODUCT} element={<ProductAddV2 />} />
              <Route
                path={ROUTES.PRODUCT_LIST_CATEGORY.pattern}
                element={<ProductCategoryV2 />}
              />
              <Route
                path={ROUTES.EDIT_PRODUCT.pattern}
                element={<ProductEditV2 />}
              />
            </Route>
            <Route path={ROUTES.STOCK_OVERVIEW} element={<StockOverview />} />
            <Route
              path={ROUTES.STOCK_OVERVIEW_PRODUCT_DETAILS.pattern}
              element={<StockOverviewProduct />}
            />
            <Route
              path={ROUTES.COLLECTIONS}
              element={
                <Dashboard
                  width={1024}
                  parentComponent={<CollectionsList />}
                  parentPart={"minmax(400px,30%)"}
                  childPart={"1fr"}
                />
              }
            >
              <Route
                path={ROUTES.COLLECTION_DETAILS.pattern}
                element={<CollectionDetails />}
              ></Route>
            </Route>

            {sellarDistributionBetaEnabled && (
              <>
                <Route
                  path={ROUTES.DISTRIBUTION}
                  element={
                    <Dashboard
                      width={1024}
                      parentComponent={<DistributionCollectionsList />}
                      parentPart={"minmax(400px,30%)"}
                      childPart={"1fr"}
                    />
                  }
                >
                  <Route
                    path={ROUTES.DISTRIBUTION_DETAILS_PROCESSING.pattern}
                    element={<DistributionProcessingDetails />}
                  ></Route>
                  <Route
                    path={ROUTES.DISTRIBUTION_DETAILS_ALLOCATED.pattern}
                    element={<DistributionAllocatedDetails />}
                  ></Route>
                </Route>

                <Route
                  path={ROUTES.DISTRIBUTION_PALLET_SHIPMENTS}
                  element={
                    <Dashboard
                      width={1024}
                      parentComponent={<DistributionPalletShipmentsList />}
                      parentPart={"minmax(400px,30%)"}
                      childPart={"1fr"}
                    />
                  }
                >
                  <Route
                    path={ROUTES.DISTRIBUTION_PALLET_SHIPMENT_DETAILS.pattern}
                    element={<DistributionPalletShipmentDetails />}
                  ></Route>
                </Route>
              </>
            )}

            <Route path={ROUTES.NEW_DELIVERY_AREA} element={<DeliveryArea />} />
            <Route
              path={ROUTES.UPDATE_DELIVERY_AREA.pattern}
              element={<DeliveryArea />}
            />
            <Route
              path={ROUTES.DELIVERY_CHARGES}
              element={
                <Dashboard
                  width={1024}
                  parentComponent={<DeliveryTiers />}
                  parentPart={"minmax(400px,30%)"}
                  childPart={"1fr"}
                />
              }
            >
              <Route
                path={ROUTES.DELIVERY_METHOD_CHARGES.pattern}
                element={<ForDeliveryMethod />}
              />
            </Route>
            <Route
              path={ROUTES.DELIVERY_SETTINGS}
              element={<DeliverySettings />}
            />

            <Route
              path={ROUTES.LAYOUT_GROUPING}
              element={<StorefrontLayoutRoute />}
            />
            <Route
              path={ROUTES.LAYOUT_GROUPING_GROUP.pattern}
              element={<StorefrontLayoutRoute />}
            />
            <Route
              path={ROUTES.STOREFRONT_CONTENT}
              element={<StorefrontContent />}
            />
            <Route
              path={ROUTES.STOREFRONT_SETTINGS}
              element={<StorefrontSettings />}
            />

            <Route
              path={ROUTES.STOREFRONT_SHARE}
              element={<StorefrontShare />}
            />
            <Route
              path={ROUTES.SUPPLIER_DISTRIBUTION}
              element={<SupplierDistribution />}
            />
            {unbundlingEnabled && (
              <>
                <Route
                  path={ROUTES.DELIVERY_METHODS}
                  element={<DeliveryMethodList />}
                />
                <Route
                  path={ROUTES.DELIVERY_ZONES}
                  element={<DeliveryZones />}
                />
                <Route
                  path={ROUTES.DELIVERY_ZONE.pattern}
                  element={<DeliveryZone />}
                />
                <Route
                  path={ROUTES.DELIVERY_METHOD.pattern}
                  element={<DeliveryMethod />}
                />
                <Route
                  path={ROUTES.DELIVERY_SETTINGS_V2}
                  element={<DeliverySettingsV2 />}
                />
                <Route
                  path={ROUTES.DELIVERY_SCHEDULES}
                  element={<DeliveryScheduleList />}
                />
                <Route
                  path={ROUTES.DELIVERY_SCHEDULE_NEW}
                  element={<DeliveryArea />}
                />
                <Route
                  path={ROUTES.DELIVERY_SCHEDULE.pattern}
                  element={<DeliveryArea />}
                />
              </>
            )}
          </>
        )}
        {sellarUser?.type === "admin" && (
          <>
            <Route
              path={ROUTES.NEW_SUPPLIER}
              element={<SupplierCreatePage />}
            />
          </>
        )}
      </>
    </Route>
  </Route>
);
